import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Unidad } from 'src/app/models/unidad';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {

  unidadSelected: Unidad;
  imagen: String = '';
  latlng = "";

  constructor(
    private dataService: DataService
  ) {

  }

  ngOnInit() {
    this.dataService.currentUnidadSelected.subscribe(unidadSelected => {
      if(unidadSelected["linkMap"] !== undefined)
        this.latlng = unidadSelected["linkMap"];
      if(unidadSelected["pathImagenMap"] !== undefined)
            this.imagen = unidadSelected["pathImagenMap"];
            
    });
      
  }
}
